import styled from "styled-components";

export const VerifyParent = styled.div`
  width: 100vw;
  height: 100vh;
  background: #ffffff;
  justify-content: center;
  display: flex;
 `;


export const VerifyWrapper = styled.div`
    width: 30%;
    height: 50%;
    border: 1px solid #F2F2F2;
    border-radius: 10px;
    justify-content: center;
    line-height: 1.3rem;
    align-items: center;
    justify-content: center;
    margin-top: 10rem;
    margin-left:8rem;

    `;

export const VerifyContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: #FFFFFF;
    justify-content: center;
    margin-left:3.8rem;

    & h1{
        align-items:center;
        margin-left:5rem;
        font-weight:450;
        line-height:0.5rem;
        font-size:1.5rem;
        margin-top:2rem;
    }
    & p{
        margin-left:1rem;
    }
    `;

export const BtnWrapper = styled.div`
   display: flex;
   align-content: center; 
   margin-left:1rem;
  `;